const styles = {
    rowHeader: {
        padding: 10,
        width: "140px"
    },
    summaryContainer: {
        width: "100%",
        padding: "20px"
    },
    summaryTable: {
        width: "100%",
        // fontFamily: "'Times New Roman', Times, serif",
        borderCollapse: "collapse"
    },
    summaryHeader: {
        backgroundColor: "#696969",
        color: "#FFFFFF",
        padding: "10px",
        fontSize: "16px",
        textAlign: "start"
    },
    summaryBody: {
        backgroundColor: "#FFFFFF",
        fontSize: "14px",
        textAlign: "start"
    },
    summaryRowHead: {
        width: "35%",
        border: "1px solid #ccc",
        padding: "8px",
        fontWeight: "600",
        backgroundColor: "#f8f8f8",
        textAlign: "start"
    },
    summaryRowContent: {
        width: "65%",
        border: "1px solid #ccc",
        padding: "8px"
    }
}

export default styles;